import { Action, Reducer } from 'redux'
import { BULK_QUOTING_ACTION_TYPES } from './actions'
import { IBulkQuotingState } from './types'

const {
  BULK_QUOTING_TOOL_FAILURE,
  BULK_QUOTING_TOOL_REQUEST,
  BULK_QUOTING_TOOL_SUCCESS,
} = BULK_QUOTING_ACTION_TYPES

const defaultState = {
  fetching: false,
} as IBulkQuotingState

interface IErrorAction extends Action<string> {
  error: string
}

interface ISuccessAction extends Action<string> {}

type BulkQuotingAction = Action<string> | IErrorAction | ISuccessAction

const bulkQuotingReducer: Reducer<IBulkQuotingState, BulkQuotingAction> = (
  state = defaultState,
  action
) => {
  if (!action) return state

  switch (action.type) {
    case BULK_QUOTING_TOOL_REQUEST: {
      return {
        ...state,
        fetching: true,
        error: undefined,
      }
    }
    case BULK_QUOTING_TOOL_SUCCESS: {
      return {
        ...state,
        fetching: false,
        message: 'Uploaded for processing! Results will be emailed when completed.',
      }
    }

    case BULK_QUOTING_TOOL_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: (action as IErrorAction).error,
      }
    }

    default:
      return state
  }
}

export default bulkQuotingReducer
